import React, { useState, useEffect } from 'react'
import Header from '../../Header'
import { useLocation, useNavigate } from 'react-router-dom'
import './TesislerList.css'
import InfoCircleOrangeSvg from '../../../assets/icons/InfoCircleOrangeSvg'
import LocationPinSvg from '../../../assets/icons/LocationPinSvg'
import ConditionsCheckBox from '../ApplicationsForm/ConditionsCheckBox'
import { Button } from 'reactstrap'
import OptionsModal from './OptionsModal'
import LocationModal from './LocationModal'
import TubitakWarningModal from '../TUBITAKDergiForm/Modals/TubitakWarningModal'
import axios from 'axios'
import Loading from '../../Loading'

const TesislerList = (props) => {
  const { state } = useLocation()
  const navigate = useNavigate()
  const [selectedTesis, setSelectedTesis] = useState(null)
  const [selectedTesisOptions, setSelectedTesisOptions] = useState(null)
  const [selectedTesisLocation, setSelectedTesisLocation] = useState(null)
  const [optionModalOpen, setOptionModalOpen] = useState(false)
  const [locationModalOpen, setLocationModalOpen] = useState(false)
  const [checkbox, setCheckbox] = useState(false)
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const getData = () => {
      return new Promise((resolve, reject) => {
        let my_data = []
        let get_data = state?.tesisler_data
        for (const item of get_data) {
          my_data.push({
            id: item.id,
            title: item.title,
            adress: item.address,
            location: {
              name: item.location_name,
              lat: item.location_lat,
              lng: item.location_long,
            },
            img:
              'https://app.yanibasimdakaratay.com/uploads/dijital_basvurular/tesisler/' +
              item.img,
            options: JSON.parse(item.options),
          })
        }
        resolve(my_data)
      })
    }

    if (state?.tesisler_data) {
      getData().then((data) => {
        setData(data)
      })
    }
  }, [state?.tesisler_data])

  const [warningModalOpen, setWarningModalOpen] = useState({
    state: '',
    active: false,
    message: '',
  })
  const onFinish = () => {
    if (selectedTesis && checkbox) {
      setLoading(true)
      axios.post(`${process.env.REACT_APP_BASE_URL}/api/dijital_basvuru/sosyal-tesisleri-basvuru`, {
        data: JSON.stringify({
          id: state?.id,
          name: state?.name,
          surname: state?.surname,
          address_type: state?.selectedAddress,
          address: state?.adress,
          ilce: state?.ilce || null,
          mahalle:
            state?.mahalle === 'Seçiniz...' ? null : state?.mahalle || null,
          selectedTesis: selectedTesis?.id,
          kosullar: checkbox,
          tc: state?.tc || null,
          date: state?.date || null,
          basvuru_type: state?.basvuru_type,
        }),
        token: JSON.parse(localStorage.getItem('token')),
      }).then((res) => {
        setLoading(false)
        if (res.data.code === 200) {
          navigate('/success-applications', {
            state: { id: res.data.result },
          })
        } else if (res.data.code === 400) {
          setWarningModalOpen({
            state: 'responseMessage',
            active: true,
            message: res.data.message,
          })
        }
      })
    } else {
      if (!selectedTesis) {
        setWarningModalOpen({ state: 'selectList', active: true })
      } else if (!checkbox) {
        setWarningModalOpen({ state: 'checkbox', active: true })
      }
    }
  }

  return (
    <>
      {loading ? (
        <Loading
          formText={'Belgeleriniz yükleniyor,'}
          text={'Lütfen bekleyiniz...'}
          formLodading={true}
        />
      ) : null}
      <div className='hide-scrollbar'>
        <div
          style={{
            backgroundColor: '#fff',
            position: 'sticky',
            top: 0,
            zIndex: 999,
          }}
        >
          <Header onClick={() => navigate(-1)} />
        </div>
        <div className='' style={{ margin: '0 1rem' }}>
          <div className='label'>
            {'Kayıt Olmak İstediğiniz Tesisi Seçiniz'}
          </div>
          {data?.map((item) => (
            <div
              key={item.id}
              className='list-item'
              onClick={() => {
                setSelectedTesis(item)
              }}
            >
              <div className='selectedCircle'>
                <div
                  className='circle'
                  style={{
                    backgroundColor:
                      selectedTesis?.id === item.id ? '#205c42' : '#fff',
                    borderRadius: '100%',
                  }}
                ></div>
              </div>
              <div className='item-image'>
                <img alt='' src={item.img} />
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  margin: '0 0 0 0.5rem',
                }}
              >
                <div>
                  <div className='item-title'>{item.title}</div>
                  <div className='item-adress'>{item.adress}</div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '0.5rem',
                  }}
                >
                  <button
                    className='ozellikBtn'
                    onClick={(e) => {
                      setSelectedTesisOptions(item.options)
                      setOptionModalOpen(true)
                      e.stopPropagation()
                    }}
                  >
                    <InfoCircleOrangeSvg width={'1rem'} height={'1rem'} />
                    <div style={{ margin: '0 0 0 0.5rem' }}>
                      Tesis Özellikleri
                    </div>
                  </button>
                  <button
                    className='konumBtn'
                    onClick={(e) => {
                      setSelectedTesisLocation(item.location)
                      setLocationModalOpen(true)
                      e.stopPropagation()
                    }}
                  >
                    <LocationPinSvg width={'1rem'} height={'1rem'} />
                    <div style={{ margin: '0 0 0 0.3rem' }}>Konum</div>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div>
          <ConditionsCheckBox
            checkbox={checkbox}
            setCheckbox={setCheckbox}
            basvuru_sartlari_title={state?.basvuru_sartlari_title}
            basvuru_sartlari_aciklama={state?.basvuru_sartlari_aciklama}
          />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '1rem',
            marginBottom: '2rem',
          }}
        >
          <Button
            block
            className='tubitakTamamla'
            onClick={onFinish}
            style={{
              marginLeft: '1rem',
              marginRight: '1rem',
              backgroundColor: '#285843',
              borderRadius: '20px',
              padding: '0.6rem 0',
            }}
          >
            Başvuruyu Tamamla
          </Button>
        </div>
      </div>
      {selectedTesisOptions && (
        <OptionsModal
          show={optionModalOpen}
          onHide={() => setOptionModalOpen(false)}
          options={selectedTesisOptions}
        />
      )}

      {selectedTesisLocation && (
        <LocationModal
          show={locationModalOpen}
          onHide={() => setLocationModalOpen(false)}
          location={selectedTesisLocation}
        />
      )}
      <TubitakWarningModal
        show={warningModalOpen.active}
        onHide={() => setWarningModalOpen({ state: '', active: false })}
        state={warningModalOpen.state}
        message={warningModalOpen.message}
      />
    </>
  )
}

export default TesislerList
